import { SprinklrChatWidget } from '@/components/business/Sprinklr/widget'
import {
  SupportChatActions,
  SupportChatSeller,
  SupportChatUser,
} from '../../types'

const logSprinklrLoadDebug = (
  sellerId: SupportChatSeller['id'],
  hasExistingUser: boolean
) => {
  if (process.env.ENV !== 'production') {
    console.info('[SupportChat] Sprinklr load', {
      sellerId,
      hasExistingUser,
      widgetUrl: `${process.env.SPRINKLR_URL}/${process.env.SPRINKLR_APP_ID}`,
    })
  }
}

export const createSprinklrProvider = (
  seller: SupportChatSeller,
  user: SupportChatUser
): SupportChatActions => ({
  load: () => {
    const hasExistingUser = Boolean(globalThis?.sprChatSettings?.user)

    logSprinklrLoadDebug(seller.id, hasExistingUser)

    if (!hasExistingUser) {
      SprinklrChatWidget(seller, user)
    }
  },
  open: () => {
    globalThis?.sprChat?.('open')
  },
  disable: () => {
    globalThis?.sprChat?.('disable')
  },
  enable: () => {
    globalThis?.sprChat?.('enable')
  },
  logout: () => {
    globalThis?.sprChat?.('disable')
    globalThis?.sprChat?.('clearSession')
  },
})
